import React, { useState } from 'react';
import Modal from '@omilia/modal';
import Dropzone from '@omilia/dropzone';
import Button, { ButtonGroup } from '@omilia/button';
import styled from 'styled-components';

export type Props = {
  isLoading: boolean;
  onImport: (file: File) => void;
  onClose: () => void;
};

const SContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  & > ul {
    margin: 14px 0 0 0;
  }
`;

const SButtonGroup = styled(ButtonGroup)`
  align-self: flex-end;
  margin-top: 20px;
`;

const ImportXpackModal = ({ isLoading = false, onImport, onClose }: Props) => {
  const [files, setFiles] = useState<File[]>([]);

  const handleUploadFiles = async () => {
    await onImport(files[0]);

    onClose();
  };

  return (
    <Modal open glyph="xpacks" title="Import xPack" onClose={onClose}>
      <SContainer>
        <Dropzone
          accept=".nlu"
          description="Drop .nlu here to import"
          isLoading={isLoading}
          multiple={false}
          onChange={setFiles}
        />
        <SButtonGroup>
          <Button
            color="secondary"
            data-test="import-file-cancel-button"
            variant="text"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            data-test="import-file-button"
            disabled={files.length < 1}
            loading={isLoading}
            variant="contained"
            onClick={handleUploadFiles}
          >
            Import
          </Button>
        </SButtonGroup>
      </SContainer>
    </Modal>
  );
};

export default ImportXpackModal;
